import './i18n/config'
import 'react-toastify/dist/ReactToastify.css'
import './ReactToastifyCustom.css'

import {
  GlobalStyles,
  theme,
  ThemeProvider,
} from '@orobix/orobix-fe-components'
import { createRoot } from 'react-dom/client'
import { ThemeProvider as JssThemeProvider } from 'react-jss'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { BrowserRouter as Router } from 'react-router-dom'
import { Slide, ToastContainer } from 'react-toastify'

import { App } from './App'
import { reportWebVitals } from './reportWebVitals'
import { StoreProvider } from './store/store'

const container = document.getElementById('root')
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
})

root.render(
  <Router>
    {/* <React.StrictMode> */}
    <ThemeProvider theme={theme}>
      <JssThemeProvider theme={theme}>
        <GlobalStyles>
          <QueryClientProvider client={queryClient}>
            <ReactQueryDevtools initialIsOpen={false} />

            <StoreProvider>
              <App />

              <ToastContainer
                position="bottom-right"
                autoClose={5000}
                newestOnTop
                closeOnClick
                pauseOnFocusLoss
                draggable
                pauseOnHover
                transition={Slide}
              />
            </StoreProvider>
          </QueryClientProvider>
        </GlobalStyles>
      </JssThemeProvider>
    </ThemeProvider>
    {/* </React.StrictMode> */}
  </Router>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
